import React, {PropTypes} from "react";

class MainPage extends React.Component {

  constructor() {
    super();
  }

  render() {
    return (
      <div>
        <br/>
        <h2>THIS IS Secondaryt PAGE</h2>
      </div>
    );
  }
}

MainPage.propTypes = {};

export default MainPage;





/** WEBPACK FOOTER **
 ** ./src/components/SecondaryPage.js
 **/